import axios from "./common.js";
// axios.defaults.baseURL = "https://test-api.hakspay.cn/";
axios.defaults.headers.post["Content-Type"] = "application/json";
import { Message } from "element-ui";
import { testR, officialId,baseUrl } from "./common";

/** 获取微信会员卡信息
 *  datas内容
 * wxhelper/v2/card/query
 *  "describe": "string",
 *  "classify_no": "string",
 *  "classify_name": "string",
 *  "parent_classify_no": "string"
 */
export const wxServiceMembershipQuery = async function (
  card_id = "p4XwGw7k3VsyoY1D7VQ9JP6SwmrQ",
  appid = officialId
) {
  var data = {
    appid,
    data: {
      card_id
    }
  };
  try {
    return await axios.post("wxhelper/v2/card/query", JSON.stringify(data));
  } catch (e) {
    Message.error(e);
  }
};

/**
 * 修改会员卡信息
 * /wxhelper/v2/card/set
 */
export const wxServiceMembershipSet = async function (
  data,
  card_id = "p4XwGw7k3VsyoY1D7VQ9JP6SwmrQ",
  appid = officialId
) {
  var data = {
    appid,
    data: {
      card_id,
      member_card: {
        ...data
      }
    }
  };
  try {
    return await axios.post("wxhelper/v2/card/set", JSON.stringify(data));
  } catch (e) {
    Message.error(e);
  }
};

/**
 * 设置开卡填写内容
 * /wxhelper/v2/ card/SetActiveFormData
 */
export const wxServiceCardSetActiveFormData = async function (
  data,
  card_id = "p4XwGw7k3VsyoY1D7VQ9JP6SwmrQ",
  appid = officialId
) {
  var data = {
    appid,
    data: {
      card_id,
      ...data
    }
  };
  try {
    return await axios.post(
      "wxhelper/v2/card/SetActiveFormData",
      JSON.stringify(data)
    );
  } catch (e) {
    Message.error(e);
  }
};

/**
 * /wxhelper/v2/ticket/generateqrcode
 * 生成二维码
 */
export const wxServiceGenerateqrcode = async function (
  card_id = "p4XwGw7k3VsyoY1D7VQ9JP6SwmrQ",
  appid = officialId
) {
  const outer_id = localStorage.getItem("token_type") == "service" ? "2" : "1";
  var data = {
    appid,
    data: {
      action_name: "QR_CARD",
      action_info: {
        card: {
          card_id,
          outer_str: outer_id == "2" ? localStorage.getItem("service_no") : localStorage.getItem("merchant_id"),
          outer_id
        }
      }
    }
  };
  console.log(JSON.stringify(data));
  try {
    return await axios.post(
      "wxhelper/v2/ticket/generateqrcode",
      JSON.stringify(data)
    );
  } catch (e) {
    Message.error(e);
  }
};

/**
 * 通过公众号appid 获取公众号创建的 微信会员卡
 * @param {"wx59275b1f7f83e45f"|"wxf003ddc051b4643b"} appid 公众号的appid wx59275b1f7f83e45f - 测试公众号 wxf003ddc051b4643b - 淮安快刷
 */
export const wxServiceGetCardList = async function (appid) {
  try {
    return new Promise((resovle, reject) => {
      axios.get(`wxhelper/v2/card/list?appid=${appid}`).then(res => {
        if (res.data && res.data.resp_data && res.data.resp_data.card_id_list) {
          resovle(res.data.resp_data.card_id_list);
        } else {
          resovle(false);
        }
      });
    })

  } catch (e) {
    Message.error(e);
  }
}

/**
 * 获取店铺关注链接
 */
export const getAttention = function (token_type) {
  const mch_no = localStorage.getItem("merchant_id");
  let url = "wxhelper/v2/Qr/MerchantAttention" + `${token_type == 'account' ? '?mch_no=' + mch_no : ''}`;
  return axios.get(url)
};

/**
 * 获取小程序跳转链接
 */
export const getMiniQrcode = function(){
  return `${baseUrl}/wxhelper/v2/card/GetUserOpenID?mch_no=${localStorage.getItem("merchant_id")}`
}

/**
 * 用户登录
 * @param {*} code 获取到的code
 * @returns 
 */
export const wxGetAcToken = function (code) {
  return axios.get(`wxHelper/v2/login/GetLoginAccessToken?code=${code}`);
}

